import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { PersonioSyncRow } from "./utils";

/** Props Interface */
interface PersonioSyncResultCellProps {
	row: PersonioSyncRow;
}

export function PersonioSyncResultCell({ row }: PersonioSyncResultCellProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!row.result) return null;

	/** Render */
	return (
		<Tag
			variant="plain"
			color={row.result.outcome === "failed" ? "red" : "emerald"}
		>
			{t(`integrations.personio_sync.outcomes.${row.result.outcome}`)}
		</Tag>
	);
}
